import { useEffect, useRef, useState } from 'react';

export default function CustomeRemoteVideo({ stream, name, css }) {
    const videoRef = useRef(null);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || !stream) return;

        video.srcObject = stream;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let intervalId;
        const pausedRef = { current: false };

        const safeSetPaused = (value) => {
            if (pausedRef.current !== value) {
                pausedRef.current = value;
                setPaused(value);
            }
        };

        const isFrameBlack = (frame) => {
            for (let i = 0; i < frame.length; i += 4) {
                const r = frame[i];
                const g = frame[i + 1];
                const b = frame[i + 2];

                if (r !== 0 || g !== 0 || b !== 0) {
                    return false;
                }
            }
            return true;
        };

        const checkFrozen = () => {
            if (!video.videoWidth || !video.videoHeight) return;

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const frame = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

            const isBlack = isFrameBlack(frame);
            safeSetPaused(isBlack);
        };

        intervalId = setInterval(checkFrozen, 1500);

        return () => clearInterval(intervalId);
    }, [stream]);

    return (
        <>
            <video ref={videoRef} autoPlay playsInline className={css} />
            {
                paused && <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white text-lg font-semibold rounded-xl">
                    <div className='w-32 h-32 rounded-full flex items-center justify-center overflow-hidden border-4 border-white shadow shadow-white bg-primeLight text-3xl'>{name[0]}</div>
                </div>
            }
        </>
    )
}
